<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">门店老板信息</h2>
        <div class="weui-form__desc">门店老板信息,可根据实际情况进行调整与修改</div>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">姓名</label></div>
              <div class="weui-cell__bd">
                <input  class="weui-input" placeholder="请填写你本人名称" v-model="formSet.bossName" prop="bossName">
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input  class="weui-input" placeholder="填写门店注册时手机号" pattern="[0-9]*" maxlength="16" v-model="formSet.bossPhone" prop="bossPhone">
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips" @click="handleSubmit">确定</a>
        <a class="weui-btn weui-btn_warn" href="javascript:" id="showTooltips1" @click="logonOut">退出</a>
      </div>
    </div>
  </div>
</template>

<script type="es6">
export default {
  data () {
    const validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      formSet: {
        id: '',
        bossName: '',
        bossPhone: '',
        userFlag: 'bossman'
      },
      flag: '',
      bossRules: {
        bossName: [
          {required: true, message: '请输入您的名字!', trigger: 'blur'}
        ],
        bossPhone: [
          {required: true, trigger: 'blur', validator: validatorPhone}
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$axios({
        method: 'post',
        url: '/v1/wShopBoss/save',
        data: this.formSet
      }).then((response) => {
        if (response.data.code == 200) {
          this.$storage.saveStorage("boss", response.data.data)
          this.$router.push({path: 'bossShops'})
        }else{
          this.$message.error(response.data.msg);
        }
      }).catch((error) => {
        this.$message.error(error.data.msg === '' ? '保存失败' : error.data.msg)
      })
    },
    logonOut () {
      this.$storage.removeStorage()
      this.$weui.topTips('退出成功,后续操作请重新登录');
      this.$router.push({path: '/'})
    },
    getBossInfo(){
      this.$axios({
        method: 'get',
        url: '/v1/wShopBoss/info?id=' + this.formSet.id
      }).then((response) => {
        if (response.data.code === 200) {
          console.log("获取",response.data.data)
          this.formSet = response.data.data
        }
      }).catch((error) => {
        console.log('获取失败', '保存失败')
      })
    }
  },
  mounted () {
    let user = this.$storage.fetchStorage("user")
    if(user != null && user != '' ) {
      this.formSet.id = user.id
      this.getBossInfo()
    }
  },
  components: {

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Register/bossInfo.vue